module.exports = __webpack_public_path__ + "img/10.9cb14829.jpg";